<div class="container-fluid">
    <div class="row">
		<mat-card-content>
			<div class="d-flex justify-content-between">
				<mat-card-title>Ficha del paciente</mat-card-title>
				<span mat-dialog-close><mat-icon>close</mat-icon></span>
			</div>
			<div class="row">
				<mat-divider></mat-divider>
			</div>
			<div class="row gy-3 mb-0">
				<div class="d-flex align-items-center justify-content-between">
					<div>
						<h3 class="fw-bold">{{ patientObj.data.fullName }}</h3>
						<p class="mb-0">{{ patientObj.data.patientRecordId }} <span>Última atención: 06/11/2023 3:00pm</span></p>
					</div>
					<button mat-stroked-button color="primary" (click)="redirectTo()">Expediente clínico</button>
				</div>
				<mat-divider></mat-divider>
				<mat-card-title>Datos generales</mat-card-title>
				<mat-divider></mat-divider>
				<div class="icon-card mb-3 mt-0">
				<div class="row">
					<div class="col-4">
						<p class="title-icon mb-0 card-center">Sexo biológico</p>
						<i class="fa-xl fa-regular fa-venus-mars card-center m-4"></i>
						<p class="subtitle-icon card-center mb-0">{{ patientObj.data.sexStr }} </p>
					</div>
					<div class="col-4">
						<p class="title-icon mb-0 card-center">Edad</p>
						<i class="fa-xl fa-regular fa-image-polaroid-user card-center m-4"></i>
						<p class="subtitle-icon card-center mb-0">{{ patientObj.data.patientBirthDate | age }}</p>
					</div>
					<div class="col-4">
						<p class="title-icon mb-0 card-center">Fecha de nacimiento</p>
						<i class="fa-xl fa-regular fa-baby card-center m-4"></i>
						<p class="subtitle-icon card-center mb-0">{{ patientObj.data.patientBirthDate }}</p>
						</div>
					</div>	
				</div>
				<mat-card-title>Datos médicos</mat-card-title>
				<mat-divider></mat-divider>
				<div class="icon-card  mb-3 mt-0">
					<div class="row">
						<div class="col-md"[ngClass]='classEstructure'>
							<p class="title-icon mb-0 card-center">Tipo de sangre</p>
							<i class="fa-xl fa-regular fa-droplet card-center m-4"></i>
							<p class="subtitle-icon card-center mb-0">O+</p>
						</div>
						<div class="col-md"[ngClass]='classEstructure'>
							<p class="title-icon mb-0 card-center">Peso</p>
							<i class="fa-xl fa-regular fa-weight-scale card-center mt-4 mb-4 mr-4"></i>
							<p class="subtitle-icon card-center mb-0">90kg</p>
						</div>
						<div class="col-md"[ngClass]='classEstructure'>
							<p class="title-icon mb-0 card-center">Altura</p>
							<i class="fa-xl fa-regular fa-ruler-vertical card-center mt-4 mb-4 mr-4"></i>
							<p class="subtitle-icon card-center mb-0">1.70m</p>
						</div>
						<div class="col-md"[ngClass]='classEstructure'>
							<p class="title-icon mb-0 card-center">Especialidad</p>
							<i class="fa-xl fa-regular fa-regular fa-hand-holding-medical card-center m-4"></i>
							<p class="subtitle-icon card-center mb-0">Medicina interna</p>
						</div>
						<div class="col-4 col-md" *ngIf="roomFlag" >
							<p class="title-icon mb-0 card-center">Habitación</p>
							<i class="fa-xl fa-regular fa-bed card-center m-4"></i>
							<p class="subtitle-icon card-center mb-0">C-25</p>
						</div>
						<div class="col-4 col-md" *ngIf="fumFlag">
							<p class="title-icon mb-0 card-center">FUM</p>
							<i class="fa-xl fa-regular fa-calendar card-center m-4"></i>
							<p class="subtitle-icon card-center mb-0">02/04/2024</p>
						</div>
					</div>
				</div>
				<mat-card-title>Alertas</mat-card-title>
				<mat-divider></mat-divider>
				<div class="icon-card  mb-3 mt-0">
					<div class="row">
						<div class="col-4">
							<p class="title-icon mb-0 card-center">Alergias</p>
							<i class="fa-xl fa-regular fa-hand-dots card-center m-4" [ngClass]="colorNameAllergi"></i>
							<p class="subtitle-icon card-center mb-0">Ninguna</p>
						</div>
						<div class="col-4">
							<p class="title-icon mb-0 card-center">Epidemiología</p>
							<i class="fa-xl fa-regular fa-virus-covid card-center m-4"></i>
							<p class="subtitle-icon card-center mb-0">Ninguna</p>
						</div>
						<div class="col-4">
							<p class="title-icon mb-0 card-center">Consentimientos</p>
							<i class="fa-xl fa-regular fa-file-medical card-center m-4"></i>
							<p class="subtitle-icon card-center mb-0">Sí</p>
							</div>
						</div>	
					</div>
				<mat-card-title>Datos de contacto</mat-card-title>
				<mat-divider></mat-divider>
				<div class="table-responsive">
					<app-table [tableDto]="table" [msgNoData]="msgNoData"></app-table>			
				</div>
				<mat-divider></mat-divider>
				<div class="m-0">
					<button mat-stroked-button mat-dialog-close type="button" color="info" class="float-end">Cerrar</button>
				</div>
			</div>
		</mat-card-content>
	</div>
</div>